import type { ISerialize } from '@/objects/ISerialize';
import { MapPoint } from './MapPoint';

export class GeoFenceRectangle implements ISerialize {
    public BottomRight: MapPoint | null;

    public TopLeft: MapPoint | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { BottomRight?: MapPoint | null; TopLeft?: MapPoint | null }) {
        this.BottomRight = values.BottomRight ?? null;

        this.TopLeft = values.TopLeft ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"BottomRight": ${!this.BottomRight ? null : this.BottomRight?.serialize()}` +
            ',' +
            `"TopLeft": ${!this.TopLeft ? null : this.TopLeft?.serialize()}` +
            '}'
        );
    }

    /**
     * Creates an instance of GeoFenceRectangle from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { BottomRight?: MapPoint | null; TopLeft?: MapPoint | null }): GeoFenceRectangle {
        return new GeoFenceRectangle(values);
    }

    public static _FromServerJson(json: any): GeoFenceRectangle {
        return new GeoFenceRectangle({
            BottomRight: json.BottomRight ? MapPoint._FromServerJson(json.BottomRight) : null,
            TopLeft: json.TopLeft ? MapPoint._FromServerJson(json.TopLeft) : null,
        });
    }

    /**
     * Creates an instance of GeoFenceRectangle from another instance of GeoFenceRectangle.
     * @param other The GeoFenceRectangle you want to clone
     * @returns A cloned GeoFenceRectangle
     */
    public static FromOther(other: GeoFenceRectangle): GeoFenceRectangle {
        return GeoFenceRectangle._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return GeoFenceRectangle.FromOther(this);
    }

    static NAME_OF_CLASS = 'GeoFenceRectangle';
}
